import * as LDClient from 'launchdarkly-js-client-sdk';
import type { LDContext } from 'launchdarkly-js-client-sdk';

let client: LDClient.LDClient | null = null;

export const getLDClient = (): LDClient.LDClient | null => client;

export const initLDClient = (context: LDContext, clientId: string) => {
  if (client) {
    // If client exists but context changed, identify with new context
    client.identify(context);
    return client;
  }

  client = LDClient.initialize(clientId, context);

  return client;
};
